import { render, staticRenderFns } from "./LessonPractice.vue?vue&type=template&id=7a9f9fb8"
import script from "./LessonPractice.vue?vue&type=script&lang=js"
export * from "./LessonPractice.vue?vue&type=script&lang=js"
import style0 from "./LessonPractice.vue?vue&type=style&index=0&id=7a9f9fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports